import styled from "styled-components";

export const StyledBackButton = styled.span`
  cursor: pointer;
  font-size: 0.9rem;
  color: var(--tws-brown);
  font-weight: 500;
  transition: var(--tws-transition);
  user-select: none;

  &:hover {
    color: var(--tws-dark);
  }
`;

export const StyledImageProduct = styled.img`
  width: 100%;
  max-height: 500px;
  object-fit: cover;
  border-radius: var(--tws-radius-lg);
`;

export const StyledTwoColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;

  @media (min-width: 768px) {
    flex-direction: row;

    & > :first-child {
      flex: 0 0 50%;
    }
    & > :last-child {
      flex: 1;
    }
  }
`;
